import React from 'react';
import { motion } from 'framer-motion';

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

export const Footer = () => (
  <motion.footer
    className="border-t py-12"
    style={{ backgroundColor: 'rgba(0,0,0,0.88)', borderColor: 'rgba(255,255,255,0.1)' }}
    initial={{ opacity: 0 }}
    whileInView={{ opacity: 1 }}
    viewport={{ once: true, margin: '-40px' }}
    transition={{ duration: 0.8, ease: 'easeOut' }}
  >
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex flex-col md:flex-row justify-between items-center gap-6">
        <div style={{ fontFamily: 'DM Sans', fontSize: '13px', fontWeight: 600, letterSpacing: '0.5px' }}>
          <span style={{ color: '#FFFFFF' }}>TREP</span>
          <span style={{ color: '#1E40AF' }}>TRADING</span>
          <span style={{ color: '#FFFFFF' }}>TECHNOLOGIES</span>
        </div>

        <button
          onClick={() => scrollTo('about')}
          className="text-sm"
          style={{ color: '#9CA3AF', fontFamily: 'DM Sans', transition: 'color 0.18s ease' }}
          onMouseEnter={e => (e.currentTarget.style.color = '#FFFFFF')}
          onMouseLeave={e => (e.currentTarget.style.color = '#9CA3AF')}
        >
          About
        </button>
      </div>

      <div className="h-px my-8" style={{ backgroundColor: 'rgba(255,255,255,0.1)' }} />

      <div className="text-center">
        <p className="text-xs leading-relaxed mb-4" style={{ color: '#6B7280', fontFamily: 'DM Sans' }}>
          <span style={{ fontWeight: 600 }}>Risk Disclosure:</span> Trading involves substantial risk of loss. Past performance does not guarantee future results. All content is confidential and for educational purposes only.
        </p>
        <p className="text-xs" style={{ color: '#6B7280', fontFamily: 'DM Sans' }}>
          © {new Date().getFullYear()} TrepTradingTechnologies. All rights reserved.
        </p>
      </div>
    </div>
  </motion.footer>
);
